<template>
  <div
    :style="classObject"
    class="ems-title"
  >
    <div>
      <slot />
    </div>
    <div>
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['size', 'bold', 'line', 'padding', 'color'],
  data() {
    return {}
  },
  computed: {
    classObject() {
      return {
        fontSize: `${this.size || 16}px`,
        fontWeight: typeof this.bold === 'string' ? 'bold' : 'normal',
        borderBottom: `${typeof this.line === 'string' ? 1 : 0}px solid #E0E2E6`,
        padding: `${this.padding || 20}px`,
        color: typeof this.color === 'string' ? this.color : '#333'
      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.ems-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/component/base/emsTitle.vue